var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCloseable),expression:"isCloseable"}],attrs:{"src":require("../assets/img/remove.png")},on:{"click":_vm.removeChip}})])}
var staticRenderFns = []

export { render, staticRenderFns }